// extracted by mini-css-extract-plugin
export default {"cta":"_x8g21","signin":"__Euj_","body":"_OlWhL"};